import React from 'react'
import { Button, Card, Typography } from '@telavita-core/react-design-kit'

import { useContent } from './useContent'
import * as S from './styles'

export function TelavitaHealthSpaceCard(): JSX.Element {
  const { url, text } = useContent()

  return (
    <Card
      customClassName='PatientHome__Card'
      variant='regular'
    >
      <Typography weight='bold'>
        Espaço Telavita
      </Typography>

      <S.HealthSpaceImage />        

      <S.WrapperContent>
        <Typography variant='content2'>
          {text}
        </Typography>
      </S.WrapperContent>
      
      <S.Link href={url} target='_blank' rel='noopener noreferrer'>
        <Button variant='text' uppercase={false}>
          Ver mais
        </Button>
      </S.Link>

    </Card>
  )
}